// Abertura do Conselho (styleguide §11c.1): overlay da Sala do Comitê e da
// entrada de Workspace Agent. O servidor segura a cena e tira o overlay; o
// hook só decide o que o servidor não sabe:
//
//   * pular: clique/toque no overlay ou Escape → `skip_committee_entry`
//     (o botão "Pular" tem `phx-click` próprio, então cliques nele passam);
//   * uma vez por sessão do navegador: a chave `data-council-key` vai para o
//     sessionStorage na primeira exibição; se a mesma abertura voltar
//     (reconexão do LiveView, "voltar à sala"), o hook esconde o overlay e
//     pede `mode: "seen"`, que o remove sem saída;
//   * movimento reduzido: `prefers-reduced-motion` → `mode: "reduced"`, e o
//     servidor troca para a cena estática (`council--still`) com hold curto.
//
// sessionStorage pode não existir ou lançar (aba privada, iframe sem
// storage): sem ele a abertura só toca de novo, nunca quebra.

const REDUCED_MOTION = "(prefers-reduced-motion: reduce)"
const EVENT = "skip_committee_entry"

function alreadySeen(key) {
  if (!key) return false
  try {
    return window.sessionStorage.getItem(key) === "1"
  } catch (_error) {
    return false
  }
}

function markSeen(key) {
  if (!key) return
  try {
    window.sessionStorage.setItem(key, "1")
  } catch (_error) {
    /* sem storage: a abertura apenas volta a tocar */
  }
}

function prefersReducedMotion() {
  try {
    return Boolean(window.matchMedia && window.matchMedia(REDUCED_MOTION).matches)
  } catch (_error) {
    return false
  }
}

const CommitteeCouncil = {
  mounted() {
    this.key = this.el.dataset.councilKey
    this.entry = this.el.dataset.entry || "project_room"
    this.skipped = false

    // A Sala sempre permanece visível por quatro segundos a partir da
    // montagem real. Não oferece salto por ESC, clique ou sessão anterior.
    if (this.entry === "project_room") {
      this.signal(prefersReducedMotion() ? "ready_reduced" : "ready")
      return
    }

    if (alreadySeen(this.key)) {
      // Já tocou nesta sessão: some antes do primeiro quadro e avisa o
      // servidor, que tira o overlay sem a saída de 320 ms.
      this.el.style.visibility = "hidden"
      this.signal("seen")
      return
    }

    markSeen(this.key)
    if (prefersReducedMotion()) this.signal("reduced")

    this.onKeydown = event => {
      if (event.key === "Escape") this.skip()
    }
    this.onClick = event => {
      if (event.target.closest("[phx-click]")) return
      this.skip()
    }

    window.addEventListener("keydown", this.onKeydown)
    this.el.addEventListener("click", this.onClick)
  },

  reconnected() {
    if (this.entry === "project_room") {
      this.signal(prefersReducedMotion() ? "ready_reduced" : "ready")
      return
    }
    // O processo novo do LiveView remonta a abertura do zero; quem já a viu
    // nesta sessão não precisa vê-la de novo.
    if (alreadySeen(this.key)) this.signal("seen")
  },

  destroyed() {
    if (this.onKeydown) window.removeEventListener("keydown", this.onKeydown)
    if (this.onClick) this.el.removeEventListener("click", this.onClick)
  },

  skip() {
    if (this.skipped) return
    this.skipped = true
    this.signal("skip")
  },

  signal(mode) {
    this.pushEvent(EVENT, {entry: this.entry, mode})
  }
}

export default CommitteeCouncil
